/*
 * Created Date: Mon, 26th Jul 2021, 17:45:18 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2021 The Distance
 */

import React from 'react';
import { Edit } from 'react-admin';
import AdminForm from './form';

const AdminEdit = (props) => {
  const { resource } = props;
  return (
    <Edit
      mutationMode="optimistic"
      title={`resources.${resource}.titles.edit`}
      {...props}
    >
      <AdminForm />
    </Edit>
  );
};

export default AdminEdit;
